import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider as UrqlProvider } from 'urql';
import App from './App';
import { gqlClient } from './lib/gql';
import { AuthProvider } from './auth/AuthContext';
import { isFirebaseEnabled } from './auth/firebase';
import './index.css';

// Workspace id is resolved at runtime by <WorkspaceGate> via the `me` query,
// which works without an X-Workspace-Id header (the api bootstraps to the user's
// first workspace). No hardcoded ids — they go stale across DB re-seeds.
void isFirebaseEnabled;

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthProvider>
      <UrqlProvider value={gqlClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </UrqlProvider>
    </AuthProvider>
  </StrictMode>,
);
